export default {
		addAccount: 'opservice/enterpriseadmin/save', //账号管理,添加账号
		updateAccount: 'opservice/enterpriseadmin/update',//租户管理管理员更新企业管理员信息
		deleteAccount: 'opservice/enterpriseadmin/delete',//租户管理员删除企业管理员
		changePasswd: 'opservice/enterpriseadmin/changePasswd',//企业管理员修改密码
    accountInfo: 'opservice/enterpriseadmin',//get 租户管理员查看企业管理员详情
    validUsername: 'opservice/enterpriseadmin/validUsername', // 验证用户名是否存在

    getAccountPage: 'opservice/enterpriseadmin/paged', //分页获取账户列表
    getAccountPage1:'opservice/enterpriseadmin/paged/by/orgid', 
    getAllAccount: 'opservice/enterpriseadmin/list', //获取该租户下的所有账户列表

    registAccount: 'opservice/regist/regist',//企业用户注册
    existsAccount: 'opservice/regist/exists',//检查用户名是否已存在
   
    

    assignOrgs: 'opservice/enterpriseadmin/assignOrgs', //租户管理员分派企业管理员权限
}
